import { useState } from 'react'
import {
  Edit,
  ListButton,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from 'react-admin'
import { ToggleI18nButton, UpsertSelection } from '~/components'

const SelectionName = (props) => {
  const record = useRecordContext(props)

  return <span>Selection: {record ? `${record.name}` : ''}</span>
}

const SelectionEditActions = ({ data, showI18n, setShowI18n }) => (
  <TopToolbar>
    <ToggleI18nButton showI18n={showI18n} setShowI18n={setShowI18n} />
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

export const SelectionEdit = (props, record) => {
  const [showI18n, setShowI18n] = useState(true)

  // Predefined selections may not be edited, so they get no save button.
  const SelectionEditToolbar = (props) => {
    const record = useRecordContext(props)
    return record?.predefined ? (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    ) : (
      <Toolbar {...props} />
    )
  }

  return (
    <Edit
      title={<SelectionName />}
      actions={<SelectionEditActions showI18n={showI18n} setShowI18n={setShowI18n} />}
      {...props}
      redirect='list'
    >
      <SimpleForm warnWhenUnsavedChanges toolbar={<SelectionEditToolbar />}>
        <UpsertSelection {...props} showI18n={showI18n} />
      </SimpleForm>
    </Edit>
  )
}

export default SelectionEdit
